import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex relative w-full aspect-auto h-64 bg-brand-dark-gray p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-brand-black z-30" }, null, -1)
const _hoisted_4 = { class: "flex w-full px-4 space-x-3 -mt-10 z-50" }
const _hoisted_5 = { class: "flex relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-14 w-14 z-50" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex rounded-full w-full h-full bg-brand-dark-gray text-brand-light-gray border-4 border-brand-black" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "m-auto h-4 fill-current",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0.375458 3.66957C0.665645 1.98488 2.00472 0.746476 3.69477 0.489325C5.31411 0.242933 7.53559 0 10 0C12.4644 0 14.6859 0.242933 16.3052 0.489325C17.9953 0.746476 19.3344 1.98488 19.6245 3.66957C19.8268 4.84372 20 6.33525 20 8C20 9.66475 19.8268 11.1563 19.6245 12.3304C19.3344 14.0151 17.9953 15.2535 16.3052 15.5107C14.8238 15.7361 12.8384 15.9586 10.6241 15.9949L4.50873 19.6085C3.84211 20.0024 3 19.5219 3 18.7476V15.344C1.64656 14.8939 0.624559 13.7766 0.375458 12.3304C0.173212 11.1563 0 9.66475 0 8C0 6.33525 0.173212 4.84372 0.375458 3.66957ZM4 6C4 5.44772 4.44772 5 5 5H15C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H5C4.44771 7 4 6.55228 4 6ZM4 10C4 9.44772 4.44772 9 5 9H9C9.55228 9 10 9.44772 10 10C10 10.5523 9.55228 11 9 11H5C4.44772 11 4 10.5523 4 10Z"
      })
    ])
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col max-w-fit whitespace-nowrap overflow-hidden mt-auto mb-3" }
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = { class: "font-medium text-white text-2xl truncate" }
const _hoisted_11 = { class: "flex space-x-1 text-brand-light-gray" }
const _hoisted_12 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "my-auto w-3 h-3 fill-current",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" })
], -1)
const _hoisted_14 = { class: "my-auto text-sm" }
const _hoisted_15 = { class: "flex w-full grid grid-cols-4 mt-6" }
const _hoisted_16 = { class: "flex flex-col items-center w-full" }
const _hoisted_17 = { class: "flex flex-col items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray" }, "Followers", -1)
const _hoisted_19 = { class: "flex flex-col items-center w-full" }
const _hoisted_20 = { class: "flex flex-col items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray" }, "Following", -1)
const _hoisted_22 = { class: "flex flex-col items-center w-full" }
const _hoisted_23 = { class: "flex flex-col items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray" }, "Friends", -1)
const _hoisted_25 = { class: "flex flex-col items-center w-full" }
const _hoisted_26 = { class: "flex flex-col items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray" }, "Winks", -1)
const _hoisted_28 = { class: "text-white text-xl font-medium" }
const _hoisted_29 = { class: "text-brand-light-gray" }
const _hoisted_30 = { class: "text-white text-xl font-medium" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-brand-light-gray" }, "Following", -1)
const _hoisted_32 = { class: "text-white text-xl font-medium relative" }
const _hoisted_33 = {
  key: 0,
  class: "absolute -top-1 -right-2.5"
}
const _hoisted_34 = { class: "w-4 h-4 bg-brand-lime flex rounded-full" }
const _hoisted_35 = { class: "m-auto text-xxs text-brand-black leading-normal font-medium" }
const _hoisted_36 = { class: "text-brand-light-gray" }
const _hoisted_37 = { class: "text-white text-xl font-medium" }
const _hoisted_38 = { class: "text-brand-light-gray" }
const _hoisted_39 = {
  key: 0,
  class: "flex flex-col items-center -space-y-1 w-full"
}
const _hoisted_40 = { class: "text-white text-xl font-medium" }
const _hoisted_41 = { class: "text-brand-light-gray" }
const _hoisted_42 = {
  key: 0,
  class: "flex px-4 mt-7 justify-center"
}
const _hoisted_43 = {
  key: 1,
  class: "flex w-full space-x-2"
}
const _hoisted_44 = {
  key: 0,
  class: "m-auto font-medium"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  key: 0,
  class: "m-auto font-medium"
}
const _hoisted_49 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-white m-auto z-50",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = {
  key: 0,
  class: "m-auto font-medium"
}
const _hoisted_54 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-white m-auto z-50",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 0,
  class: "mx-auto font-medium"
}
const _hoisted_59 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-white m-auto z-50",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = {
  key: 0,
  class: "mx-auto font-medium"
}
const _hoisted_64 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-white m-auto z-50",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = {
  key: 0,
  class: "m-auto font-medium"
}
const _hoisted_69 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-white m-auto z-50",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]
const _hoisted_73 = { class: "bg-brand-black flex flex-col mt-3 border-b border-brand-dark-gray z-50" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current w-6",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" })
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current",
  height: "22",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M81.1 416H366.9c-7.8-54.3-54.4-96-110.9-96H192c-56.4 0-103.1 41.7-110.9 96zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM224 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144z" })
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("svg", {
  height: "19",
  class: "fill-current my-auto",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" })
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V4C11 3.73478 10.8946 3.48043 10.7071 3.29289C10.5196 3.10536 10.2652 3 10 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V10C3 10.2652 3.10536 10.5196 3.29289 10.7071C3.48043 10.8946 3.73478 11 4 11ZM14 11H20C20.2652 11 20.5196 10.8946 20.7071 10.7071C20.8946 10.5196 21 10.2652 21 10V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3H14C13.7348 3 13.4804 3.10536 13.2929 3.29289C13.1054 3.48043 13 3.73478 13 4V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11ZM4 21H10C10.2652 21 10.5196 20.8946 10.7071 20.7071C10.8946 20.5196 11 20.2652 11 20V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13H4C3.73478 13 3.48043 13.1054 3.29289 13.2929C3.10536 13.4804 3 13.7348 3 14V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21ZM14 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V14C21 13.7348 20.8946 13.4804 20.7071 13.2929C20.5196 13.1054 20.2652 13 20 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V20C13 20.2652 13.1054 20.5196 13.2929 20.7071C13.4804 20.8946 13.7348 21 14 21Z" })
], -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 11.3875H8.00156V3.39062H0V11.3875ZM9.99844 4.38906V6.39062H24V4.38906H9.99844ZM9.99844 10.3891H24V8.3875H9.99844V10.3891ZM9.99844 16.3891H24V14.3875H9.99844V16.3891ZM9.99844 20.3875H24V18.3859H9.99844V20.3875ZM0 21.3906H8.00156V13.3891H0V21.3906Z" })
], -1)
const _hoisted_79 = {
  key: 1,
  class: "flex flex-col p-4"
}
const _hoisted_80 = { class: "flex flex-col space-y-2 mt-4" }
const _hoisted_81 = {
  key: 1,
  class: "flex flex-grow py-10 px-5"
}
const _hoisted_82 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col space-y-2 items-center\"><div class=\"flex flex-col w-full items-center space-y-1 px-2\"><div class=\"flex text-white text-lg font-medium text-center\">It&#39;s a 2-way street!</div><div class=\"text-brand-light-gray text-sm text-center\">If you want to see who&#39;s looking at you then you must be prepared for others to know you&#39;re looking at them! </div></div><div class=\"text-xxs text-brand-light-gray text-opacity-50\">You can opt back into profile view receipts from your account settings. </div></div>", 1)
const _hoisted_83 = [
  _hoisted_82
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_photo_consumer = _resolveComponent("photo-consumer")!
  const _component_photo_provider = _resolveComponent("photo-provider")!
  const _component_user_avatar = _resolveComponent("user-avatar")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_user_badges = _resolveComponent("user-badges")!
  const _component_user_account_type_badge = _resolveComponent("user-account-type-badge")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_user_profile_views = _resolveComponent("user-profile-views")!
  const _component_user_profile_reviews = _resolveComponent("user-profile-reviews")!
  const _component_user_profile_personal = _resolveComponent("user-profile-personal")!
  const _component_user_profile_gallery = _resolveComponent("user-profile-gallery")!
  const _component_user_profile_posts = _resolveComponent("user-profile-posts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_photo_provider, {
            key: 0,
            class: "relative z-10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_photo_consumer, {
                src: _ctx.user.cover_photo
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_img, {
                    class: _normalizeClass([{
                'opacity-0' : !_ctx.user.cover_photo
              }, "absolute top-0 left-0 w-full h-full object-cover bg-cover z-20"]),
                    src: _ctx.user.cover_photo
                  }, null, 8, ["class", "src"]),
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["src"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_photo_provider, {
              key: 0,
              class: "relative z-40"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_photo_consumer, {
                  src: _ctx.user.avatar
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user_avatar, {
                      class: "border-[4px] border-brand-black rounded-full",
                      "account-type-badge": false,
                      user: _ctx.user as UserBasicInformationInterface,
                      size: 24
                    }, null, 8, ["user"])
                  ]),
                  _: 1
                }, 8, ["src"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
              key: 1,
              animated: "",
              class: "w-32 bg-brand-dark-gray h-32 m-0 rounded-full border-4 border-transparent"
            }))
          : _createCommentVNode("", true),
        (!_ctx.loading && !_ctx.isAuthUser && _ctx.allowDirectMessage)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "absolute -bottom-3 right-0",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.directMessage && _ctx.directMessage(...args)))
            }, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{
              'opacity-0' : _ctx.loading
             }, "flex space-x-1 mt-1.5"])
            }, [
              _createVNode(_component_user_badges, {
                class: "flex",
                user: _ctx.user
              }, null, 8, ["user"]),
              (_ctx.user)
                ? (_openBlock(), _createBlock(_component_user_account_type_badge, {
                    key: 0,
                    class: "my-auto flex",
                    user: _ctx.user
                  }, null, 8, ["user"]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user.name), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
              key: 2,
              animated: "",
              class: "h-7 m-0 mt-1 w-7/12 rounded-lg"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.loading && _ctx.showLocation && _ctx.user.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.user.location.name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                key: 1,
                animated: "",
                class: "h-4 m-0 mt-1 w-32 rounded-lg"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_ion_skeleton_text, {
                  animated: "",
                  class: "h-6 m-0 w-6 rounded-lg"
                }),
                _hoisted_18
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_ion_skeleton_text, {
                  animated: "",
                  class: "h-6 m-0 w-6 rounded-lg"
                }),
                _hoisted_21
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_ion_skeleton_text, {
                  animated: "",
                  class: "h-6 m-0 w-6 rounded-lg"
                }),
                _hoisted_24
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_ion_skeleton_text, {
                  animated: "",
                  class: "h-6 m-0 w-6 rounded-lg"
                }),
                _hoisted_27
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewFollowers && _ctx.viewFollowers(...args))),
              class: "flex flex-col items-center -space-y-1 w-full"
            }, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.user.followers), 1),
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.pluralize('Follower', _ctx.user.followers)), 1)
            ]),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.viewFollowing && _ctx.viewFollowing(...args))),
              class: "flex flex-col items-center -space-y-1 w-full"
            }, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.user.following), 1),
              _hoisted_31
            ]),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewFriends && _ctx.viewFriends(...args))),
              class: "flex flex-col items-center -space-y-1 w-full relative"
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", null, _toDisplayString(_ctx.user.friends), 1),
                (_ctx.user.friend_requests && _ctx.isAuthUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.user.friend_requests), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.pluralize('Friend', _ctx.user.friends)), 1)
            ]),
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewWinks && _ctx.viewWinks(...args))),
              class: "flex flex-col items-center -space-y-1 w-full"
            }, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.user.winks), 1),
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.pluralize('Wink', _ctx.user.winks)), 1)
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.user.likes), 1),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.pluralize('Like', _ctx.user.likes)), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isAuthUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                key: 0,
                animated: "",
                class: "w-full h-14 m-0 rounded-full"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isAuthUser && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.follow && _ctx.follow(...args))),
                  class: _normalizeClass([{
              'bg-brand-lime text-brand-black': !_ctx.isFollowing,
              'border-brand-dark-gray border-2 text-white': _ctx.isFollowing
            }, "flex flex-grow rounded-lg p-2 px-2"])
                }, [
                  (!_ctx.followBusy)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.isFollowing ? 'Unfollow' : 'Follow'), 1))
                    : (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        class: _normalizeClass([{
                'text-white' : _ctx.isFollowing,
                'text-brand-dark-gray' : !_ctx.isFollowing,
               }, "animate-spin h-5 w-5 m-auto z-50"]),
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }, _hoisted_47, 2))
                ], 2),
                (_ctx.userFriendRequests.includes(_ctx.user.id))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.isFriends && !_ctx.isFriendRequested && _ctx.user.preferences[_ctx.PreferenceKey.AllowFriendRequests] === '1')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.friendRequest && _ctx.friendRequest(...args))),
                            class: "flex flex-grow rounded-lg bg-brand-dark-gray text-white p-2 px-2"
                          }, [
                            (!_ctx.friendsBusy)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Accept friend request"))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_52))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (!_ctx.userFriendRequests.includes(_ctx.user.id))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.isFriends && !_ctx.isFriendRequested && _ctx.user.preferences[_ctx.PreferenceKey.AllowFriendRequests] === '1')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.friendRequest && _ctx.friendRequest(...args))),
                            class: "flex flex-grow rounded-lg bg-brand-dark-gray text-white p-2 px-2"
                          }, [
                            (!_ctx.friendsBusy)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Send friend request"))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_54, _hoisted_57))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isFriendRequested)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelFriendRequest && _ctx.cancelFriendRequest(...args))),
                            class: "flex flex-grow rounded-lg border-brand-dark-gray border-2 text-white p-2 px-2"
                          }, [
                            (!_ctx.friendsBusy)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Cancel friend request"))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_59, _hoisted_62))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isFriends)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeFriend && _ctx.removeFriend(...args))),
                      class: "flex flex-grow rounded-lg border-brand-dark-gray border-2 text-white p-2 px-2"
                    }, [
                      (!_ctx.friendsBusy)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Unfriend"))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_64, _hoisted_67))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.wink && _ctx.wink(...args))),
                  class: "flex rounded-lg border-2 border-brand-dark-gray bg-brand-dark-gray text-white p-2 px-4"
                }, [
                  (!_ctx.winkBusy)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Wink 😉"))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_69, _hoisted_72))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_73, [
      _createVNode(_component_ion_segment, {
        class: "relative z-50",
        onIonChange: _ctx.profileTabChanged,
        "swipe-gesture": false,
        mode: "ios",
        value: _ctx.tab
      }, {
        default: _withCtx(() => [
          (_ctx.isAuthUser && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                key: 0,
                value: "views"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_74
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_segment_button, { value: "personal" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _hoisted_75
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.loading && _ctx.user.subscribed)
            ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                key: 1,
                value: "reviews"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _hoisted_76
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_segment_button, { value: "gallery" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _hoisted_77
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_segment_button, { value: "feed" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _hoisted_78
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onIonChange", "value"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          _createVNode(_component_ion_skeleton_text, {
            animated: "",
            class: "h-5 m-0 w-4/12 rounded-lg"
          }),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_ion_skeleton_text, {
              animated: "",
              class: "h-3 m-0 w-12/12 rounded-lg"
            }),
            _createVNode(_component_ion_skeleton_text, {
              animated: "",
              class: "h-3 m-0 w-12/12 rounded-lg"
            }),
            _createVNode(_component_ion_skeleton_text, {
              animated: "",
              class: "h-3 m-0 w-10/12 rounded-lg"
            }),
            _createVNode(_component_ion_skeleton_text, {
              animated: "",
              class: "h-3 m-0 w-5/12 rounded-lg"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.isAuthUser && _ctx.tab === 'views' && _ctx.profileViewReceipts)
            ? (_openBlock(), _createBlock(_component_user_profile_views, {
                key: 0,
                user: _ctx.user
              }, null, 8, ["user"]))
            : _createCommentVNode("", true),
          (_ctx.isAuthUser && _ctx.tab === 'views' && !_ctx.profileViewReceipts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_83))
            : _createCommentVNode("", true),
          (_ctx.tab === 'reviews')
            ? (_openBlock(), _createBlock(_component_user_profile_reviews, {
                key: 2,
                user: _ctx.user,
                "is-auth-user": _ctx.isAuthUser
              }, null, 8, ["user", "is-auth-user"]))
            : _createCommentVNode("", true),
          (_ctx.tab === 'personal')
            ? (_openBlock(), _createBlock(_component_user_profile_personal, {
                key: 3,
                user: _ctx.user,
                "is-auth-user": _ctx.isAuthUser
              }, null, 8, ["user", "is-auth-user"]))
            : _createCommentVNode("", true),
          (_ctx.tab==='gallery')
            ? (_openBlock(), _createBlock(_component_user_profile_gallery, {
                key: 4,
                "user-id": _ctx.user.id,
                "is-auth-user": _ctx.isAuthUser
              }, null, 8, ["user-id", "is-auth-user"]))
            : _createCommentVNode("", true),
          (_ctx.tab === 'feed')
            ? (_openBlock(), _createBlock(_component_user_profile_posts, {
                key: 5,
                "user-id": _ctx.user.id,
                "auth-user": _ctx.authUser,
                "is-auth-user": _ctx.isAuthUser
              }, null, 8, ["user-id", "auth-user", "is-auth-user"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}